import { render, staticRenderFns } from "./ModifyPasswordModal.vue?vue&type=template&id=6815bf89&scoped=true"
import script from "./ModifyPasswordModal.vue?vue&type=script&lang=js"
export * from "./ModifyPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ModifyPasswordModal.vue?vue&type=style&index=0&id=6815bf89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6815bf89",
  null
  
)

export default component.exports